import React,{Component} from 'react';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import moment from 'moment';
import "moment/locale/ru";
import * as companiesActions from '../../actions/companiesActions';

import Spinner from '../Shared/Spinner';
import './style.css';

moment.locale('ru');

class Companies extends Component{
    constructor(props){
        super(props)
        let {companiesActions} = this.props;

        companiesActions.Get();

    }
    render(){
        let {companies} = this.props;
        return(
            <div className="content companies-page">

                {
                    companies.fetching ?
                        <Spinner
                            styles={{
                                backgroundColor: "#37474F"
                            }}
                            className="absolute"
                        />
                        : null
                }

                <div className="table-wrapp">

                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Id</th>
                                <th>Название</th>
                                <th>Последняя обработка цен</th>
                                <th>Url</th>
                                <th>
                                    Обработано товаров
                                </th>
                                <th>Ссылка на выгрузку</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                companies.data.length > 0 ?
                                    companies.data.map((company, index) => {
                                        return (
                                            <tr key={index} className="no-pointer">
                                                <td>{company.id}</td>
                                                <td>{company.name}</td>
                                                <td>{moment(company.logDetailsModel.endDateTime).format('DD.MM.YYYY hh:mm')}</td>
                                                <td>
                                                    <a href={company.url} target="_blank" title="открыть в новом окне">{company.url}</a>
                                                </td>
                                                <td>
                                                    {company.logDetailsModel.offersCount}
                                                </td>
                                                <td>
                                                    <a href={company.csv} target="_blank" title="открыть в новом окне">{company.csv}</a>
                                                </td>
                                            </tr>
                                        );
                                    })
                                    : companies.set ?
                                    <tr>
                                        <td colSpan="4">
                                            Нет данных
                                        </td>
                                    </tr>
                                    :null
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return{
        companies:state.companies
    }
}

function mapDispatchToProps(dispatch) {
    return{
        companiesActions:bindActionCreators(companiesActions,dispatch)
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Companies);



// WEBPACK FOOTER //
// ./src/components/Companies/index.jsx